import React from "react"

// @ts-ignore
// import ProjectIcon from "../../../../../core/gd-ui/project-icon/project-icon"
import {NewProject_SelectedType} from "../new-project-main";

export default function newProject_getMyTemplates() {
    const templates = _.chain(gd.session.templatesList.models)
        .filter(t=>t.companyId === gd.companyId && !t.isDeleted && !t.isPage)
        .orderBy(t=>t.sortPosition)
        .value()

    const res: any = []

    // we dont need fodler here anymore
    // res.push({
    //     typeId      : "workfolder",
    //     icon        : "i5-folder",
    //     title       : "Folder",
    //     description : "Use folders to categorize your projects or to group work items."
    // });

    templates.map(template=>{
        res.push({
            id              : template.id,
            typeId          : NewProject_SelectedType.TEMPLATE,
            icon            : template.iconClass,
            // iconComponent   : <ProjectIcon className="option-icon" projectId={template.id}/>,
            title           : template.name,
            description     : template.description ? template.description : "No description"
        })
    })

    return res
}